import React from "react";
import { FormFieldTypes } from "../../../../data/formFieldType";

export const CorporateInformationData = {
  name: "CourseProviderApplicationFormData",

  initialState: {
    organizationfalls: "yes",
    registeredCompanyName: "",
    UENNumber: "",
    typeofCompany: "",
    organisationLogo: "",
    organisationProfile: "",
    businessCategories: "",
    country: null,
    mainPhoneNumberId: "",
    mainPhoneNumber: "",
    generalEmail: "",
    website: "",
    businessAddressLine1: "",
    businessAddressLine2: "",
    businessAddressLine3: "",
    businessAddressCountry: "",
    businessPostalCode: "",
    mailingAddresssameasBusinessAddress: false,
    mailAddressLine1: "",
    mailAddressLine2: "",
    mailAddressLine3: "",
    mailAddressCountry: "",
    mailPostalCode: "",
    billingDetailssameasBusinessAddress: false,
    billingCompanyName: "",
    billingContactPerson: "",
    billingContactNumber: "",
    billingContactNumberId: "",
    billingContactEmail: "",
    billingAddressLine1: "",
    billingAddressLine2: "",
    billingAddressLine3: "",
    billingAddressCountry: "",
    billingPostalCode: "",
    companyisGovernmentAgency: "no",
    nameofMinistry: "",
    department: "",
    businessUnit: "",
    billingName: "",
    billingNameId: "",
    billingNumber: "",
    billingNumberId: "",
    areyouaPSPCListedOrganisation:"no",
    pspcListedOrganisation: null,
  },

  formFields: [
    {
      id: "hideTitle",
      lable:
        "Only government agencies, professional bodies, or relevant trade associations may apply to be a CPD Course Provider",
      Field_Name: "hideTitle",
      fieldType: FormFieldTypes.MAINFORMTITLE,
      dataField: "hideTitle",
      fieldSetting: {
        formTitle:
          "Only government agencies, professional bodies, or relevant trade associations may apply to be a CPD Course Provider",
      },
      style: {
        containerCss: "col-lg-12 mb-3 text-left d-none alert-title",
      },
    },

    {
      id: "registeredCompanyName",
      lable: "Registered Company Name (as per ACRA or Registry records)",
      Field_Name: "Registered Company Name (as per ACRA or Registry records)",
      fieldType: FormFieldTypes.INPUT,
      dataField: "registeredCompanyName",
      fieldSetting: {
        placeholder: "",
        allowSpace: true,
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12 mb-3",
      },
    },
    {
      id: "UENNumber",
      lable: "UEN/ Company Registration Number",
      Field_Name: "UEN Number",
      fieldType: FormFieldTypes.INPUT,
      dataField: "UENNumber",
      fieldSetting: {
        placeholder: "",
        allowSpace: true,
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12 mb-3 hide-num-dropdown",
      },
    },
    // {
    //   id: "validateUEN",
    //   fieldType: FormFieldTypes.COMPONENT,
    //   additionalComponent:
    //   <Buttons
    //     buttonText="Validate"
    //     buttonTypeClassName="btn success-btn ml-auto"
    //     isDisable={true}
    //   // onClick={clickEvent}
    //   />,
    //   style: {
    //     containerCss: "col-md-2 mt-auto mb-3",
    //   },
    // },
    {
      id: "typeofCompany",
      lable: "Country of Incorporation",
      Field_Name: "Country of Incorporation",
      fieldType: FormFieldTypes.SELECT,
      dataField: "typeofCompany",
      fieldSetting: {
        placeholder: "",
        options: [],
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12 mb-3",
      },
    },
    {
      id: "organisationLogo",
      lable: "Company Logo (please upload in jpg/png format max 2mb)",
      Field_Name: "file",
      fieldType: FormFieldTypes.FILE,
      dataField: "organisationLogo",
      fieldSetting: {
        // presentFileName: null,
        placeholder: "",
        // isDownloadable: false,
        acceptedFiles: ".jpg, .png, .jpeg",
        imageCrop: true,
        viewImage: true,
        maxFileSizeInKB: 2048,
      },
    },
    {
      id: "organisationProfile",
      lable: "Organisation Profile",
      Field_Name: "Organisation Profile",
      fieldType: FormFieldTypes.SELECT,
      dataField: "organisationProfile",
      fieldSetting: {
        placeholder: "Select",
        options: [],
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12 mb-3",
      },
    },
    {
      id: "businessCategories",
      lable: "Business Categories",
      Field_Name: "Business Categories",
      fieldType: FormFieldTypes.SELECT,
      dataField: "businessCategories",
      fieldSetting: {
        placeholder: "Select",
        options: [],
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12 mb-3",
      },
    },
    {
      id: "country",
      lable: "Country",
      Field_Name: "Country",
      fieldType: FormFieldTypes.SELECT,
      dataField: "country",
      fieldSetting: {
        placeholder: "Select",
        options: [],
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12 mb-3",
      },
    },
    {
      id: "mainPhoneNumber",
      lable: "Main Phone Number",
      Field_Name: ["mainPhoneNumberId", "& mainPhoneNumber"],
      fieldType: FormFieldTypes.INPUTGROUPSELECT,
      dataField: ["mainPhoneNumberId", "mainPhoneNumber"],
      fieldSetting: {
        placeholder: "Select",
        allowSpace: true,
        options: [],
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12 mb-3",
      },
    },
    {
      id: "generalEmail",
      lable: "General Email",
      Field_Name: "General Email",
      fieldType: FormFieldTypes.INPUT,
      dataField: "generalEmail",
      fieldSetting: {
        placeholder: "",
        allowSpace: true,
      },
      // validation: [{ type: "require" }, { type: "email" }],
      style: {
        containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12 mb-3",
      },
    },
    {
      id: "website",
      lable: "Website",
      Field_Name: "Website",
      fieldType: FormFieldTypes.INPUT,
      dataField: "website",
      fieldSetting: {
        placeholder: "",
        allowSpace: true,
      },
      // validation: [{ type: "require" }],
      style: {
        containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12 mb-3",
      },
    },
    {
      id: "businessAddressLine1",
      lable: "Business Address Line 1",
      Field_Name: "Business Address Line 1",
      fieldType: FormFieldTypes.INPUT,
      dataField: "businessAddressLine1",
      fieldSetting: {
        placeholder: "",
        allowSpace: true,
      },
      // validation: [{ type: "require" }],
      style: {
        containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12 mb-3",
      },
    },
    {
      id: "businessAddressLine2",
      lable: "Business Address Line 2",
      Field_Name: "Business Address Line 2",
      fieldType: FormFieldTypes.INPUT,
      dataField: "businessAddressLine2",
      fieldSetting: {
        placeholder: "",
        allowSpace: true,
      },
      // validation: [{ type: "require" }],
      style: {
        containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12 mb-3",
      },
    },
    {
      id: "businessAddressLine3",
      lable: "Business Address Line 3",
      Field_Name: "Business Address Line 3",
      fieldType: FormFieldTypes.INPUT,
      dataField: "businessAddressLine3",
      fieldSetting: {
        placeholder: "",
        allowSpace: true,
      },
      // validation: [{ type: "require" }],
      style: {
        containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12 mb-3",
      },
    },
    {
      id: "businessAddressCountry",
      lable: "Business Address Country ",
      Field_Name: "Business Address Country ",
      fieldType: FormFieldTypes.SELECT,
      dataField: "businessAddressCountry",
      fieldSetting: {
        placeholder: "",
        options: [],
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12 mb-3",
      },
    },
    {
      id: "businessPostalCode",
      lable: "Business Postal Code",
      Field_Name: "Business Postal Code",
      fieldType: FormFieldTypes.INPUT,
      dataField: "businessPostalCode",
      fieldSetting: {
        placeholder: "",
        allowSpace: true,
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12 mb-3 hide-num-dropdown",
      },
    },
    {
      id: "",
      lable: "",
      Field_Name: "",
      fieldType: FormFieldTypes.MAINFORMTITLE,
      dataField: "",
      fieldSetting: {
        placeholder: "Select",
        options: [],
      },
      style: {
        containerCss: "col-lg-5 col-xl-5 col-md-5 col-sm-12 col-12 mb-2 mb-3",
      },
    },
    {
      id: "mailingAddresssameasBusinessAddress",
      lable: "Mailing Address same as Business Address",
      Field_Name: "MailingAddresssameasBusinessAddress",
      fieldType: FormFieldTypes.CHECKBOX,
      dataField: "mailingAddresssameasBusinessAddress",
      style: {
        containerCss: "col-12 mt-3",
      },
    },

    {
      id: "mailAddressLine1",
      lable: "Mail Address Line 1",
      Field_Name: "Mail Address Line 1",
      fieldType: FormFieldTypes.INPUT,
      dataField: "mailAddressLine1",
      fieldSetting: {
        placeholder: "",
        allowSpace: true,
      },
      // validation: [{ type: "require" }],
      style: {
        containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12 mb-3",
      },
    },
    {
      id: "mailAddressLine2",
      lable: "Mail Address Line 2",
      Field_Name: "Mail Address Line 2",
      fieldType: FormFieldTypes.INPUT,
      dataField: "mailAddressLine2",
      fieldSetting: {
        placeholder: "",
        allowSpace: true,
      },
      // validation: [{ type: "require" }],
      style: {
        containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12 mb-3",
      },
    },
    {
      id: "mailAddressLine1",
      lable: "Mail Address Line 3",
      Field_Name: "Mail Address Line 3",
      fieldType: FormFieldTypes.INPUT,
      dataField: "mailAddressLine3",
      fieldSetting: {
        placeholder: "",
        allowSpace: true,
      },
      // validation: [{ type: "require" }],
      style: {
        containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12 mb-3",
      },
    },
    {
      id: "mailAddressCountry",
      lable: "Mail Address Country ",
      Field_Name: "Mail Address Country ",
      fieldType: FormFieldTypes.SELECT,
      dataField: "mailAddressCountry",
      fieldSetting: {
        placeholder: "",
        options: [],
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12 mb-3",
      },
    },
    {
      id: "mailPostalCode",
      lable: "Mail Postal Code",
      Field_Name: "Mail Postal Code",
      fieldType:  FormFieldTypes.INPUT,
      dataField: "mailPostalCode",
      fieldSetting: {
        placeholder: "",
        allowSpace: true,
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12 mb-3 hide-num-dropdown",
      },
    },

    {
      id: "billingDetailssameasBusinessAddress",
      lable: "Billing Details same as Business Address",
      Field_Name: "Billing Details same as Business Address",
      fieldType: FormFieldTypes.CHECKBOX,
      dataField: "billingDetailssameasBusinessAddress",
      style: {
        containerCss: "col-12 mt-3",
      },
    },
    {
      id: "billingCompanyName",
      lable: "Billing Company Name ",
      Field_Name: "Billing Company Name ",
      fieldType: FormFieldTypes.INPUT,
      dataField: "billingCompanyName",
      fieldSetting: {
        placeholder: "",
        allowSpace: true,
      },
      // validation: [{ type: "require" }],
      style: {
        containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12 mb-3",
      },
    },
    {
      id: "billingContactPerson",
      lable: "Billing Contact Person ",
      Field_Name: "Billing Contact Person ",
      fieldType: FormFieldTypes.INPUT,
      dataField: "billingContactPerson",
      fieldSetting: {
        placeholder: "",
        allowSpace: true,
      },
      // validation: [{ type: "require" }],
      style: {
        containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12 mb-3",
      },
    },
    {
      id: "billingContactNumber",
      lable: "Billing Contact Number",
      Field_Name: ["billingContactNumberId", "& billingContactNumber"],
      fieldType: FormFieldTypes.INPUTGROUPSELECT,
      dataField: ["billingContactNumberId", "billingContactNumber"],
      fieldSetting: {
        placeholder: "Select",
        allowSpace: true,
        options: [],
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12 mb-3",
      },
    },
    {
      id: "billingContactEmail",
      lable: "Billing Contact Email",
      Field_Name: "Billing Contact Email",
      fieldType: FormFieldTypes.INPUT,
      dataField: "billingContactEmail",
      fieldSetting: {
        placeholder: "",
        allowSpace: true,
      },
      validation: [{ type: "require" },{type : "email"}],
      style: {
        containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12 mb-3",
      },
    },

    {
      id: "billingAddressLine1",
      lable: "Billing Address Line 1",
      Field_Name: "Billing Address Line 1",
      fieldType: FormFieldTypes.INPUT,
      dataField: "billingAddressLine1",
      fieldSetting: {
        placeholder: "",
        allowSpace: true,
      },
      // validation: [{ type: "require" }],
      style: {
        containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12 mb-3",
      },
    },
    {
      id: "billingAddressLine2",
      lable: "Billing Address Line 2",
      Field_Name: "Billing Address Line 2",
      fieldType: FormFieldTypes.INPUT,
      dataField: "billingAddressLine2",
      fieldSetting: {
        placeholder: "",
        allowSpace: true,
      },
      // validation: [{ type: "require" }],
      style: {
        containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12 mb-3",
      },
    },
    {
      id: "billingAddressLine3",
      lable: "Billing Address Line 3",
      Field_Name: "Billing Address Line 3",
      fieldType: FormFieldTypes.INPUT,
      dataField: "billingAddressLine3",
      fieldSetting: {
        placeholder: "",
        allowSpace: true,
      },
      // validation: [{ type: "require" }],
      style: {
        containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12 mb-3",
      },
    },
    {
      id: "billingAddressCountry",
      lable: "Billing Address Country ",
      Field_Name: "Billing Address Country ",
      fieldType: FormFieldTypes.SELECT,
      dataField: "billingAddressCountry",
      fieldSetting: {
        placeholder: "",
        options: [],
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12 mb-3",
      },
    },
    {
      id: "billingPostalCode",
      lable: "Billing Postal Code",
      Field_Name: "Billing Postal Code",
      fieldType: FormFieldTypes.INPUT,
      dataField: "billingPostalCode",
      fieldSetting: {
        placeholder: "",
        allowSpace: true,
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12 mb-3 hide-num-dropdown",
      },
    },
    {
      id: "",
      lable: "",
      Field_Name: "",
      fieldType: FormFieldTypes.MAINFORMTITLE,
      dataField: "",
      fieldSetting: {
        formTitle: "",
      },
      style: {
        containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12 mb-3",
      },
    },
    {
      id: "companyisGovernmentAgency",
      label: "If Organisation is from Singapore’s Public Sector requiring Vendors@Gov billing",
      Field_Name: "If Organisation is from Singapore’s Public Sector requiring Vendors@Gov billing",
      fieldType: FormFieldTypes.RADIOBUTTON,
      dataField: "companyisGovernmentAgency",
      fieldSetting: {
        placeholder: "",
        options: [
          { label: "Yes", value: "yes", isDisable: false },
          { label: "No", value: "no", isDisable: false, optionClass: "mr-3" },
        ],
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-lg-12  col-12 mt-4 mb-3 x-position",
      },
    },

    {
      id: "nameofMinistry",
      lable: "Name of Ministry/ Statutory Board",
      Field_Name: "Name of Ministry/ Statutory Board",
      fieldType: FormFieldTypes.INPUT,
      dataField: "nameofMinistry",
      fieldSetting: {
        placeholder: "",
        allowSpace: true,
      },
      // validation: [{ type: "require" }],
      style: {
        containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12 mb-3",
      },
    },
    {
      id: "department",
      lable: "Department ",
      Field_Name: "Department ",
      fieldType: FormFieldTypes.INPUT,
      dataField: "department",
      fieldSetting: {
        placeholder: "",
        allowSpace: true,
      },
      // validation: [{ type: "require" }],
      style: {
        containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12 mb-3",
      },
    },
    {
      id: "businessUnit",
      lable: "Sub-Business Unit",
      Field_Name: "Sub-Business Unit",
      fieldType: FormFieldTypes.INPUT,
      dataField: "businessUnit",
      fieldSetting: {
        placeholder: "",
        allowSpace: true,
      },
      // validation: [{ type: "require" }],
      style: {
        containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12 mb-3",
      },
    },
    {
      id: "applicantRepresentativeDetails",
      lable: "",
      Field_Name: "applicantRepresentativeDetails",
      fieldType: FormFieldTypes.MAINFORMTITLE,
      dataField: "applicantRepresentativeDetails",
      fieldSetting: {
        formTitle: "",
      },
      style: {
        containerCss: "col-md-6 mb-3",
      },
    },
    {
      id: "billingName",
      lable: "Contact Name for Billing",
      Field_Name: ["salutationsID", "& Full Name"],
      fieldType: FormFieldTypes.INPUTGROUPSELECT,
      dataField: ["billingNameId", "billingName"],
      fieldSetting: {
        placeholder: "Select",
        allowSpace: true,
        options: [],
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12",
      },
    },

    {
      id: "billingNumber",
      lable: "Contact Number for Billing",
      Field_Name: "Contact Number for Billing",
      fieldType: FormFieldTypes.INPUTGROUPSELECT,
      dataField: ["billingNumberId", "billingNumber"],
      fieldSetting: {
        placeholder: "",
        allowSpace: false,
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12",
      },
    },
    {
      id: "areyouaPSPCListedOrganisation",
      label: <React.Fragment>
        Are you listed on Public Sector Panels of Consultants (PSPC)?<br></br>Check full listing { " " }
        <a
          href="https://pspc.bca.gov.sg/#/pspc/listing/default"
          target="_blank"
          rel="noopener noreferrer"
        >
          here
        </a>
      </React.Fragment>,
      Field_Name: "Are you listed on Public Sector Panels of Consultants (PSPC)? Check full listing here ",
      fieldType: FormFieldTypes.RADIOBUTTON,
      dataField: "areyouaPSPCListedOrganisation",
      fieldSetting: {
        placeholder: "",
        options: [
          { label: "Yes", value: "yes", isDisable: false },
          { label: "No", value: "no", isDisable: false, optionClass: "mr-3" },
        ],
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-lg-12 col-12 mb-2 x-position",
      },
    },
    {
      id: "pspcListedOrganisation",
      lable: "Please select your panel below:",
      Field_Name: "PSPC Listed Organisation",
      fieldType: FormFieldTypes.SELECT,
      dataField: "pspcListedOrganisation",
      fieldSetting: {
        placeholder: "",
        options: [],
        isMultiSelect: true,
      },
      validation: [],
      style: {
        containerCss: "col-lg-5 mb-2 d-none",
      },
    },
  ],

  formSetting: {
    isViewOnly: false,
  },
};